export default class AsyncResolvers {
    onResolvedAll;
    onFailedOne;
    resolvers = {};
    resolversCount;
    passed;
    failed;
    firing;
    constructor(onFailedOne, onResolvedAll) {
        this.onResolvedAll = onResolvedAll;
        this.onFailedOne = onFailedOne;
        this.resolvers = {};
        this.resolversCount = 0;
        this.passed = [];
        this.failed = [];
        this.firing = false;
    }
    add(rule) {
        const index = this.resolversCount;
        this.resolvers[index] = rule;
        this.resolversCount++;
        return index;
    }
    resolve(index) {
        const rule = this.resolvers[index];
        if (rule.passes) {
            this.passed.push(rule);
        }
        else if (!rule.passes) {
            this.failed.push(rule);
            this.onFailedOne(rule);
        }
        this.fire();
    }
    isAllResolved() {
        return this.passed.length + this.failed.length === this.resolversCount;
    }
    fire() {
        if (!this.firing)
            return;
        if (this.isAllResolved()) {
            this.onResolvedAll(this.failed.length === 0);
        }
    }
    enableFiring(firing = true) {
        this.firing = firing;
    }
}
